import styled from 'styled-components';

export const Container = styled.div`
  .profile-image {
    width: 50px;
    height: 50px;
    margin: 0 auto;
    background-size: cover;
    background-color: #eaeaea;
    background-position: center;
    border-radius: 100px;
  }

  .box-header {
    display: flex;
    align-items: center;

    .filter {
      margin-right: 20px;

      & > div {
        display: flex;
        flex-direction: column;
      }

      input {
        margin-bottom: 0;
        margin-top: 10px;
      }
    }
  }
`;

export const Filter = styled.div`
  float: right;
  font-size: 14px;
  color: #a7b3bb;

  span {
    margin-right: 10px;
  }
`;

export const Table = styled.table`
  text-align: center;
  margin-bottom: 0;

  td,
  th {
    vertical-align: middle;
  }

  .btn-small {
    padding: 1px 7px;
    font-size: 12px;
    margin: 0 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/admin/pages/UpdateFollowers/styles.js